import React, { useContext, useEffect, useState } from "react";
import { get, isEmpty, union, valuesIn } from "lodash";
import { Row, Col, Form, Dropdown, Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencilAlt,
  faTrashAlt,
  faTimes,
  faPlus,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import {
  ManagePlanLayout,
  FieldTextarea,
  AddPlans,
  FieldInput,
  FieldButtonGroup,
  FieldDropSide,
  AddButton,
  SearchableList,
  MultiSelectDropdown,
  Link,
  DayDropdown,
  FieldMultiSelectButtonGroup,
  CsplTable as Table,
  DropdownWithImage,
  DeleteWarning,
  AddToolTip,
  LoaderWrapper,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  required,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  ENTRYDATECLASSIFICATION_RULE_MAPPING,
  yesNoOptions,
  clearFieldValues,
  transformToMultiselectSave,
  tranformListToDropdownValues,
  toMultiSelectValueById,
  getNullTableItem,
  getAdvancedPathWithParam,
  ROUTES,
  usDateFormat,
  synchronizeCollection,
  getParamsFromQueryString,
} from "../../../utils";
import {
  clearLocalCacheByModel,
  createPlanStore,
  setManagePlanFlow,
  savePlanDetailsAction,
  setManagePageLevelData,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
  setchangeReviewFlag,
} from "../../../contexts";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
  useTableChecboxSelect,
} from "../../../abstracts";
import {
  getClassificationCodes,
  getPlanEntryDateClassificationMasterData,
  getEntryDate,
  saveEntryDate,
  listEntryDate,
  listSource,
  deleteEntryDate,
} from "../../../services";
import months from "../../../mocks/months.json";
import { useLocation } from "react-router-dom";

const columns = [
  {
    label: "Description",
    className: "column-addtional-EntryDate-entryDateDescription",
    columnName: "ruleName",
    link: MANAGE_PLAN_ROUTES.ADDITIONAL_ENTRYDATECLASSIFICATION_RULE,
  },

  {
    label: "Entry Date For",
    className: "column-addtional-EntryDate-entryDateFor",
    columnName: "entryDateRule",
    dataMapper: OPTIONS_DATA_MAPPER.ENTRYDATECLASSIFICATION_CRITERIA,
  },

  {
    label: "Prospective / Retrospective Criteria",
    className: "column-addtional-EntryDate-prospectiveOrRetrospectiveCriteria",
    columnName: "prospectiveOrRetrospective",
    dataMapper:
      OPTIONS_DATA_MAPPER.ENTRYDATECLASSIFICATION_PROSPECTIVEORRETROSPECTIVE,
  },
];

const AddEntryDateClassificationContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const [newFlow] = useState("");
  const location = useLocation();
  const [
    entryDateClassificationListData,
    setEntryDateClassificationListData,
  ] = useState([]);
  const [sources, setSources] = useState([]);
  const [sourcesList, setSourcesList] = useState([]);
  const { planId, flow, entryDateClassificationIndex } = useRouterParams();
  const dirtyCheck = getParamsFromQueryString("dirtyCheck");
  const formName = managePlanFormNames.ADD_ENTRYDATECLASSIFICATION;
  const fields = formFields[formName];
  const intEntryDateClassificationIndex = parseInt(
    entryDateClassificationIndex,
    10
  );
  useDeepEffect(() => {
    listSource(parseInt(planId))
      .then((response) => {
        setSources(response.employerSourcesList);
      })
      .catch((error) => {
        //Handle Error
      });
    listEntryDate(parseInt(planId))
      .then((response) => {
        setEntryDateClassificationListData(response.entryDateRules);
      })
      .catch((error) => {
        //Handle Error
      });
  }, []);
  useDeepEffect(() => {
    if (
      entryDateClassificationListData &&
      !isEmpty(entryDateClassificationListData)
    ) {
      let entryDateClassificationSources = entryDateClassificationListData
        .filter(
          (entryDateClassification) =>
            entryDateClassification["entryDateRuleFor"] === 2 &&
            entryDateClassification.id &&
            entryDateClassification.id != entryDateClassificationIndex
        )
        .map(
          (entryDateClassification) =>
            entryDateClassification["entryDateSources"]
        )
        .reduce(
          (previous, current) => [
            ...previous,
            ...current.reduce((prev, curr) => [...prev, curr["sourceId"]], []),
          ],
          []
        );
      setSourcesList(
        tranformListToDropdownValues(sources, "sourceName", "id").filter(
          (source) => !entryDateClassificationSources.includes(source.value)
        )
      );
    } else if (sources) {
      setSourcesList(tranformListToDropdownValues(sources, "sourceName", "id"));
    }
  }, [sources, entryDateClassificationListData]);
  const [getResponse, setResponse] = useState(null);
  const [apiLoading, setApiLoading] = useState(false);
  const apiResponse = get(getResponse, "entryDateRule", []);
  let eligibilityListData = get(state, "entryDateRules", []);
  const formValues = eligibilityListData;
  const additionalEntryDateClassificationRulesData = get(
    formValues,
    "additionalEntryDateRules",
    []
  ).filter((_) => !_.isDeleted);
  useDeepEffect(() => {
    if (
      formValues?.id !== entryDateClassificationIndex &&
      intEntryDateClassificationIndex != 0
    ) {
      setApiLoading(true);
      getEntryDate(intEntryDateClassificationIndex)
        .then((response) => {
          setApiLoading(false);
          // setDataLoading(false);
          if (response.isSuccessful) {
            setResponse(response);
          }
        })
        .catch((error) => {
          // setDataLoading(false);
          setApiLoading(false);
        });
    }
  }, [entryDateClassificationIndex]);

  useDeepEffect(() => {
    if (isEmpty(formValues)) {
      dispatch(
        setManagePlanLocalCache({
          model: "entryDateRules",
          data: apiResponse,
        })
      );
    }
  }, [apiResponse]);

  var planYearOtherEntryDates = get(formValues, "planYearOtherEntryDates", [
    { ruleId: entryDateClassificationIndex, month: 0, day: 0 },
  ]);
  var otherEntryDates = get(formValues, "otherEntryDates", [
    { ruleId: entryDateClassificationIndex, month: 0, day: 0 },
  ]);

  const entryDate = get(formValues, "entryDateRule");

  const additionalEntryDate = get(formValues, "additionalEntryDateRule");

  const [dates, setDates] = useState(otherEntryDates);

  const [additionalDates, setAdditionalDates] = useState(
    planYearOtherEntryDates
  );
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const handleClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (formValues != null) {
      if (!isEmpty(otherEntryDates) && entryDate == 7) {
        if (dates[0].month == null) setDates(otherEntryDates);
      }

      if (!isEmpty(planYearOtherEntryDates) && additionalEntryDate == 7) {
        if (additionalDates[0].month == null)
          setAdditionalDates(planYearOtherEntryDates);
      }
    }
  });

  useDeepEffect(() => {
    setDates(otherEntryDates);
  }, [otherEntryDates]);

  useDeepEffect(() => {
    setAdditionalDates(planYearOtherEntryDates);
  }, [planYearOtherEntryDates]);
  const mystyle = { fontWeight: 500, fontSize: ".74rem", marginBottom: "7px" };

  const DeleteToastMessage = "You are attempting to delete Entry Date Rule.";
  const DeleteToastMessageHead = "Delete Entry Date Rule?";

  const transformToMultiselect = (list, key) => {
    return (list || []).map((value) => ({
      id: 0,
      [key]: value,
      ruleId: formValues.id,
    }));
  };

  const initialValues = {
    [fields.isSwitchToPlanYearHaveDifferentEntryDates]: false,
    [fields.isAllSourcesFollowSameEntryDates]: true,
  };

  const formValuesExcludedClassifications = get(
    formValues,
    "exclusionFromRule.excludedClassifications",
    []
  );

  const onDeleteClick = () => {
    setShowWarning(true);
  };

  const handleCancelClick = () => {
    setShowWarning(false);
  };

  const handleConfirmClick1 = () => {
    setShowWarning(false);
    setApiLoading(true);
    deleteEntryDate(intEntryDateClassificationIndex).then((response) => {
      setApiLoading(false);
      if (!response.isSuccessful) {
        var x = response.errorMessages;
        if (
          //x[0].controlName == null &&
          x[0].errorCode !== null &&
          x[0].message !== null
        ) {
          setErrorMsg(`${x[0].errorCode} : ${x[0].message}`);
          setIsModalOpen(true);
        }
      } else {
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data deleted successfully",
          })
        );
        dispatch(
          setchangeReviewFlag({
            module: "entryDate",
            review: response.isCompleted,
          })
        );
        //const newPlanId = get(response, "plan.id");
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
        //clearCache();
      }
    });
  };

  const clearCache = () => {
    dispatch(clearLocalCacheByModel("entryDateRules"));
  };
  const onCancelClick = () => {
    if (
      !location.pathname?.includes(
        MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION
      )
    )
      clearCache();
  };
  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
        pathParam: [FLOW_TYPES.ADD, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      onClick: onCancelClick,
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
        pathParam: [planId],
      }),
      onClick: clearCache,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
            pathParam: [
              FLOW_TYPES.SAVE,
              planId,
              intEntryDateClassificationIndex,
            ],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTimes,
    //   link: getPathWithParam({
    //     path: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
    //     pathParam: [planId],
    //   }),
    //   onClick: clearCache,
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faPencilAlt,
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
    //         pathParam: [
    //           FLOW_TYPES.SAVE,
    //           planId,
    //           intEntryDateClassificationIndex,
    //         ],
    //       })
    //     ),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
  ];

  const getDataForSave = (values) => {
    const {
      ruleName,
      entryDateRuleFor,
      sourceId,
      entryDateRule,
      otherDescription,
      planYearOtherEntryDates,
      otherEntryDates,
      prospectiveOrRetrospective,
      isCoincidingApplicable,
      isSwitchToPlanYearHaveDifferentEntryDates,
      additionalEntryDateRule,
      additionalProspectiveOrRetrospective,
      isCoincidingApplicableForAdditional,
      entryDateSources,
      isAllSourcesFollowSameEntryDates,
      ...rest
    } = values;

    const updatedValues = {
      ...formValues,
      ...rest,
      id: intEntryDateClassificationIndex || 0,
      ruleName: ruleName || undefined,
      entryDateRuleFor: entryDateRuleFor || undefined,
      entryDateRuleType: 1,
      planId: parseInt(planId),
      entryDateRule: entryDateRule || undefined,
      otherDescription: otherDescription || null,
      otherEntryDates: entryDateRule == 7 ? otherEntryDates : [],
      prospectiveOrRetrospective: prospectiveOrRetrospective || null,
      isCoincidingApplicable: isCoincidingApplicable,
      effectiveStartDate: null,
      effectiveEndDate: null,
      entryDateOption: null,
      isAllSourcesFollowSameEntryDates:
        isAllSourcesFollowSameEntryDates || true,
      isSwitchToPlanYearHaveDifferentEntryDates:
        isSwitchToPlanYearHaveDifferentEntryDates || false,
      planYearOtherEntryDates:
        additionalEntryDateRule == 7 &&
        isSwitchToPlanYearHaveDifferentEntryDates
          ? planYearOtherEntryDates
          : [],
      additionalEntryDateRule: additionalEntryDateRule || null,
      additionalProspectiveOrRetrospective:
        additionalProspectiveOrRetrospective || null,
      isCoincidingApplicableForAdditional: isCoincidingApplicableForAdditional,
      // otherEntryDates :{

      // }
      additionalEntryDateRules: [
        ...transformToMultiselect(
          (values[fields.entryDateClassifications] || []).filter(
            (val) =>
              !get(formValues, fields.entryDateClassifications, [])
                .map((_) => _.id)
                .includes(val)
          ),
          "id"
        ),
        ...synchronizeCollection(
          get(formValues, fields.entryDateClassifications, []),
          values[fields.entryDateClassifications],
          "id"
        ),
      ],
      entryDateSources:
        entryDateRuleFor == 2
          ? [
              ...transformToMultiselect(
                (values[fields.entryDateSources] || []).filter(
                  (val) =>
                    !get(formValues, fields.entryDateSources, [])
                      .map((_) => _.sourceId)
                      .includes(val)
                ),
                "sourceId"
              ),
              ...synchronizeCollection(
                get(formValues, fields.entryDateSources, []),
                values[fields.entryDateSources],
                "sourceId"
              ),
            ]
          : [],
    };

    if (isEmpty(formValues)) {
      return updatedValues;
    }
    return updatedValues;
  };

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setApiLoading(true);
    var data = getDataForSave({
      ...values,
      otherEntryDates: dates,
      planYearOtherEntryDates: additionalDates,
    });
    delete data.undefined;
    saveEntryDate(data).then((response) => {
      setApiLoading(false);
      if (response.isSuccessful) {
        //const newPlanId = get(response, "plan.id");
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
        dispatch(
          setManagePageLevelData({
            formName: formName,
            fieldData: values,
          })
        );
        dispatch(
          setchangeReviewFlag({
            module: "entryDate",
            review: response.isCompleted,
          })
        );
        // dispatch(
        //   setManagePlanLocalCache({
        //     model: "entryDateRules",
        //     data: getDataForSave({...values,otherEntryDates:dates,planYearOtherEntryDates:additionalDates}),
        //   })
        // );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
        //clearCache();
      } else {
        var x = response.errorMessages;
        if (
          x[0].controlName == null &&
          x[0].errorCode !== null &&
          x[0].message !== null
        ) {
          setErrorMsg(`${x[0].errorCode} : ${x[0].message}`);
          setIsModalOpen(true);
        }
        setSubmitting(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
        [fields.ruleName]: get(formValues, `ruleName`),
        [fields.entryDateRuleFor]: get(formValues, fields.entryDateRuleFor),
        [fields.entryDateRule]: get(formValues, fields.entryDateRule),
        [fields.otherDescription]: get(formValues, fields.otherDescription),
        [fields.prospectiveOrRetrospective]: get(
          formValues,
          fields.prospectiveOrRetrospective
        ),
        [fields.entryDateClassifications]: additionalEntryDateClassificationRulesData?.map(
          (val) => val.id
        ),
        [fields.entryDateSources]: get(formValues, "entryDateSources", [])?.map(
          (val) => val.sourceId
        ),
        // [fields.otherEntryDates] : dates || undefined,
        // [fields.planYearOtherEntryDates] : additionalDates || undefined,
        [fields.isCoincidingApplicable]: get(
          formValues,
          fields.isCoincidingApplicable
        ),
        [fields.isSwitchToPlanYearHaveDifferentEntryDates]: get(
          formValues,
          fields.isSwitchToPlanYearHaveDifferentEntryDates,
          false
        ),
        [fields.additionalEntryDateRule]: get(
          formValues,
          fields.additionalEntryDateRule
        ),
        [fields.additionalProspectiveOrRetrospective]: get(
          formValues,
          fields.additionalProspectiveOrRetrospective
        ),
        [fields.isCoincidingApplicableForAdditional]: get(
          formValues,
          fields.isCoincidingApplicableForAdditional
        ),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        setSubmitting,
        setTouched,
        setErrors,
        errors,
        dirty,
        isSubmitting,
        ...rest
      }) => {
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const onisCoincidingApplicableChange = (value) => {
          setValues({
            ...clearFieldValues({
              values,
            }),
            [fields.isCoincidingApplicable]: value === false ? false : true,
          });
        };
        const onIsDifferentEntryDateChange = (value) => {
          setValues({
            ...clearFieldValues({
              values,
              fieldsToClear: [
                fields.additionalEntryDateRule,
                fields.additionalProspectiveOrRetrospective,
                fields.isCoincidingApplicableForAdditional,
              ],
            }),
            [fields.isSwitchToPlanYearHaveDifferentEntryDates]: value,
          });
          setTouched({
            [fields.additionalEntryDateRule]: false,
          });
        };

        const onSourceChange = (value) => {
          setValues({
            ...clearFieldValues({
              values,
              fieldsToClear: [fields.entryDateRule],
            }),
            [fields.sourceId]: value,
          });
          setTouched({
            [fields.entryDateRule]: false,
          });
        };

        const onEntryDateClassificationChange = (value) => {
          setValues({
            ...clearFieldValues({
              values,
              fieldsToClear: [
                fields.entryDateRule,
                fields.prospectiveOrRetrospective,
                fields.ruleName,
                fields.isCoincidingApplicable,
                fields.additionalEntryDateRule,
                fields.additionalProspectiveOrRetrospective,
                fields.isCoincidingApplicableForAdditional,
                fields.entryDateSources,
              ],
            }),
            [fields.entryDateRuleFor]: value,
            [fields.ruleName]: "",
            [fields.isSwitchToPlanYearHaveDifferentEntryDates]: false,
          });
          setErrors({});
        };

        const addAdditionalEntryDateClassificationClick = () => {
          setSubmitting(true);
          const newEntryDateClassificationId = entryDateClassificationIndex;
          dispatch(
            setManagePlanLocalCache({
              model: "entryDateRules",
              data: getDataForSave({
                ...values,
                otherEntryDates: dates,
                planYearOtherEntryDates: additionalDates,
              }),
            })
          );
          window.setTimeout(() => {
            history.push(
              getAdvancedPathWithParam({
                path:
                  MANAGE_PLAN_ROUTES.ADDITIONAL_ENTRYDATECLASSIFICATION_RULE,
                pathParam: [
                  FLOW_TYPES.ADD,
                  planId,
                  newEntryDateClassificationId,
                ],
                queryParam: `?dirtyCheck=${dirty}`,
              })
            );
          }, 10);
        };
        const editAdditionalEntryDateClassificationRuleClick = (
          item,
          index
        ) => {
          setSubmitting(true);
          dispatch(
            setManagePlanLocalCache({
              model: "entryDateRules",
              data: getDataForSave({
                ...values,
                otherEntryDates: dates,
                planYearOtherEntryDates: additionalDates,
              }),
            })
          );
          window.setTimeout(() => {
            history.push(
              getPathWithParam({
                path: item.link,
                pathParam: [
                  FLOW_TYPES.EDIT,
                  planId,
                  intEntryDateClassificationIndex,
                  index,
                ],
              })
            );
          }, 10);
        };

        const handleAddClick = (i) => {
          setDates([
            ...dates,
            { ruleId: entryDateClassificationListData?.id, month: 0, day: 0 },
          ]);
        };

        const handleAdd = (i) => {
          setAdditionalDates([
            ...additionalDates,
            { ruleId: entryDateClassificationListData.id, month: 0, day: 0 },
          ]);
        };

        const handleRemoveClick = (i, errors) => {
          const list = [...dates];
          for (let i = 0; i < list.length; i++) {
            delete errors[`month${i}`];
            delete errors[`day${i}`];
          }
          //const list1 = list.filter((_, index) => index != i);
          var updatedDates = [
            ...list
              .filter((_) => !_.isDeleted)
              .map((item, index) => {
                if (index === i) {
                  return { ...item, isDeleted: true };
                }
                return item;
              }),
            ...list.filter((_) => _.isDeleted),
          ];
          setDates(
            updatedDates.filter((_) => !(_.ruleId === undefined && _.isDeleted))
          );
          setFieldValue(fields.otherEntryDates, dates);
        };
        const handleRemove = (i, errors) => {
          const list = [...additionalDates];
          for (let i = 0; i < list.length; i++) {
            delete errors[`addMonth${i}`];
            delete errors[`addDay${i}`];
          }
          var updatedDates = [
            ...list
              .filter((_) => !_.isDeleted)
              .map((item, index) => {
                if (index === i) {
                  return { ...item, isDeleted: true };
                }
                return item;
              }),
            ...list.filter((_) => _.isDeleted),
          ];
          setAdditionalDates(
            updatedDates.filter((_) => !(_.ruleId === undefined && _.isDeleted))
          );
          setFieldValue(fields.planYearOtherEntryDates, additionalDates);
        };

        const handleInputChange = (name, value, index) => {
          const list = [...dates.filter((_) => !_.isDeleted)];
          list[index][name] = value;
          if (name === "month") {
            let startDate = list[index]["day"];
            startDate =
              startDate > 28
                ? value === 2
                  ? 28
                  : startDate === 31
                  ? value < 8
                    ? value % 2 !== 0
                      ? 31
                      : 30
                    : value % 2 === 0
                    ? 31
                    : 30
                  : startDate
                : startDate;
            list[index]["day"] = startDate;
          }
          const updatedDates = [...list, ...dates.filter((_) => _.isDeleted)];
          setDates(updatedDates);
          setFieldValue(fields.otherEntryDates, dates);
        };

        const handleInputChange1 = (name, value, index) => {
          const list = [...additionalDates.filter((_) => !_.isDeleted)];
          list[index][name] = value;
          if (name === "month") {
            let startDate = list[index]["day"];
            startDate =
              startDate > 28
                ? value === 2
                  ? 28
                  : startDate === 31
                  ? value < 8
                    ? value % 2 !== 0
                      ? 31
                      : 30
                    : value % 2 === 0
                    ? 31
                    : 30
                  : startDate
                : startDate;
            list[index]["day"] = startDate;
          }
          const updatedDates = [
            ...list,
            ...additionalDates.filter((_) => _.isDeleted),
          ];
          setAdditionalDates(updatedDates);
          setFieldValue(fields.planYearOtherEntryDates, additionalDates);
        };

        return (
          <LoaderWrapper isLoading={apiLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={flow}
                layoutHeader={entryDateClassificationIndex && "Entry Date Rule"}
                dirtyFlagCheck={dirtyCheck}
              >
                <Field
                  isRequired
                  name={fields.entryDateRuleFor}
                  label={"Entry Date Rule for"}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.ENTRYDATECLASSIFICATION_TYPE
                  )}
                  selectedValue={values[fields.entryDateRuleFor]}
                  value={values[fields.entryDateRuleFor]}
                  onChange={onEntryDateClassificationChange}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                  size="smd"
                />
                {values[fields.entryDateRuleFor] && (
                  <Field
                    isRequired
                    name={fields.ruleName}
                    label={"Entry Date Name"}
                    hasSuggestion
                    isSuggestionLoading={false}
                    type="text"
                    autoComplete="off"
                    value={values[fields.ruleName]}
                    onChange={handleChange}
                    disabled={isEdit && !isSave}
                    component={FieldInput}
                  />
                )}
                {values[fields.entryDateRuleFor] ===
                  ENTRYDATECLASSIFICATION_RULE_MAPPING.Source && (
                  <Field
                    isRequired
                    label="Source Name"
                    name={fields.entryDateSources}
                    value={toMultiSelectValueById(
                      values[fields.entryDateSources],
                      sourcesList
                    )}
                    disabled={isEdit && !isSave}
                    isMultiSelect
                    popupContent={
                      sourcesList != 0 ? (
                        <MultiSelectDropdown
                          label={
                            sourcesList.length === 0
                              ? "No data available"
                              : "Select applicable sources"
                          }
                          name={fields.entryDateSources}
                          onSelect={(value) =>
                            setFieldValue(fields.entryDateSources, value)
                          }
                          value={values[fields.entryDateSources]}
                          options={sourcesList}
                          disabled={isEdit && !isSave}
                        />
                      ) : (
                        <DropdownWithImage
                          label="Select Applicable sources for Eligibility rules."
                          name={fields.entryDateSources}
                          value={values[fields.entryDateSources]}
                          disabled={isEdit && !isSave}
                        />
                      )
                    }
                    component={FieldDropSide}
                  />
                )}

                {values[fields.entryDateRuleFor] ===
                  ENTRYDATECLASSIFICATION_RULE_MAPPING.Plan && (
                  <Field
                    name={fields.entryDateRule}
                    label="Plan entry date"
                    //value={values[fields.entryDateRule]}
                    isRequired
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                    )}
                    popupContent={
                      <SearchableList
                        isRadio
                        isNotTypeAhead
                        label="Select a Entry Date"
                        selectedValue={values[fields.entryDateRule]}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                        )}
                        onSelect={(value) => {
                          setFieldValue(fields.entryDateRule, value);
                          //To empty these fields when immediate
                          value == 6 &&
                            setFieldValue(
                              fields.prospectiveOrRetrospective,
                              null
                            );
                          setFieldValue(fields.isCoincidingApplicable, null);

                          value == 7 &&
                            setFieldValue(
                              fields.prospectiveOrRetrospective,
                              null
                            );

                          value != 7 &&
                            setFieldValue(fields.otherEntryDates, []);
                          setDates([
                            {
                              ruleId: entryDateClassificationListData?.id,
                              month: 0,
                              day: 0,
                            },
                          ]);
                          setFieldValue(fields.otherDescription, null);
                        }}
                      />
                    }
                    dropdownClassName="auto-grow-dropdown"
                    disabled={isEdit && !isSave}
                    component={FieldDropSide}
                  />
                )}
                {values[fields.entryDateRuleFor] ===
                  ENTRYDATECLASSIFICATION_RULE_MAPPING.Source && (
                  <Field
                    name={fields.entryDateRule}
                    label="Source entry date"
                    value={values[fields.entryDateRule]}
                    isRequired
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                    )}
                    popupContent={
                      <SearchableList
                        isRadio
                        isNotTypeAhead
                        label="Select a Source Entry Date"
                        selectedValue={values[fields.entryDateRule]}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                        )}
                        onSelect={(value) => {
                          setFieldValue(fields.entryDateRule, value);
                          //To empty these fields when immediate

                          value == 6 &&
                            setFieldValue(
                              fields.prospectiveOrRetrospective,
                              null
                            );
                          setFieldValue(fields.isCoincidingApplicable, null);

                          value == 7 &&
                            setFieldValue(
                              fields.prospectiveOrRetrospective,
                              null
                            );

                          value != 7 &&
                            setFieldValue(
                              fields.sourceEnrollmentOtherEntryDates,
                              []
                            );
                          setDates([
                            {
                              ruleId: entryDateClassificationListData?.id,
                              month: 0,
                              day: 0,
                            },
                          ]);
                          setFieldValue(fields.otherDescription, null);
                        }}
                      />
                    }
                    dropdownClassName="auto-grow-dropdown"
                    disabled={isEdit && !isSave}
                    component={FieldDropSide}
                  />
                )}
                {values[fields.entryDateRule] &&
                  values[fields.entryDateRule] === 7 && (
                    <>
                      <Field
                        name={fields.otherDescription}
                        isRequired
                        label="Other Description"
                        autoComplete="off"
                        value={values[fields.otherDescription]}
                        onChange={handleChange}
                        disabled={isEdit}
                        component={FieldTextarea}
                        size="lg"
                      />
                      <div className="small mb-1">{"Other Entry date"}</div>
                      {dates
                        .filter((_) => !_.isDeleted)
                        .map((x, i) => {
                          return (
                            <>
                              <Row>
                                {i == 0 && (
                                  <>
                                    <Col md="2">
                                      <div style={mystyle}>{"Month"}</div>
                                    </Col>
                                    <Col md="2">
                                      <div style={mystyle}>{"Day"}</div>
                                    </Col>
                                  </>
                                )}
                              </Row>
                              <Row>
                                <Col md="2">
                                  <Field
                                    isRequired
                                    key={i}
                                    name={`month${i}`}
                                    {...rest}
                                    size="sm"
                                    placeholder="Month"
                                    value={x.month}
                                    options={months.data}
                                    disabled={isEdit && !isSave}
                                    popupContent={
                                      <SearchableList
                                        label="Select a month"
                                        isNotTypeAhead
                                        options={months.data}
                                        onSelect={(value) => {
                                          handleInputChange("month", value, i);
                                        }}
                                        selectedValue={x.month}
                                      />
                                    }
                                    component={FieldDropSide}
                                  />
                                </Col>
                                <Col md="2">
                                  <Field
                                    name={`day${i}`}
                                    key={i}
                                    {...rest}
                                    size="xs"
                                    placeholder="Date"
                                    isRequired
                                    value={x.day}
                                    disabled={isEdit && !isSave}
                                    popupContent={
                                      <DayDropdown
                                        fromMonthDate={
                                          new Date(2019, x.month - 1 || 0)
                                        }
                                        onSelect={(value) => {
                                          handleInputChange("day", value, i);
                                        }}
                                        value={x.day}
                                      />
                                    }
                                    component={FieldDropSide}
                                  />
                                </Col>
                                <Col md="1">
                                  {dates.filter((_) => !_.isDeleted).length -
                                    1 ===
                                    i && (
                                    <Button
                                      variant="link"
                                      style={{ marginLeft: "5px" }}
                                      disabled={
                                        isEdit || x.month === 0 || x.day === 0
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        color="#212529"
                                        style={{
                                          fontSize: "1.4rem",
                                          color: "#3a3974",
                                          marginLeft: "5px",
                                        }}
                                        onClick={() => handleAddClick(i)}
                                      />
                                    </Button>
                                  )}
                                </Col>
                                <Col md="1">
                                  {dates.filter((_) => !_.isDeleted).length !==
                                    1 && (
                                    <>
                                      <Button
                                        variant="link"
                                        disabled={isEdit && !isSave}
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          color="#212529"
                                          style={{
                                            fontSize: "1.2rem",
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                          onClick={() =>
                                            handleRemoveClick(i, errors)
                                          }
                                        />
                                      </Button>
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </>
                          );
                        })}
                    </>
                  )}

                {values[fields.entryDateRuleFor] && (
                  <>
                    {values[fields.entryDateRule] &&
                      values[fields.entryDateRule] != 6 &&
                      values[fields.entryDateRule] != 7 && (
                        <>
                          <Field
                            name={fields.prospectiveOrRetrospective}
                            label="Prospective / Retrospective criteria"
                            value={values[fields.prospectiveOrRetrospective]}
                            isRequired
                            options={toOptionValuesFromMapper(
                              OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                            )}
                            popupContent={
                              <SearchableList
                                isRadio
                                isNotTypeAhead
                                label="Select a Prospective/Retrospective"
                                selectedValue={
                                  values[fields.prospectiveOrRetrospective]
                                }
                                options={toOptionValuesFromMapper(
                                  OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                                )}
                                onSelect={(value) => {
                                  setFieldValue(
                                    fields.prospectiveOrRetrospective,
                                    value
                                  );
                                  value == 3 &&
                                    setFieldValue(
                                      fields.isCoincidingApplicable,
                                      null
                                    );
                                }}
                              />
                            }
                            dropdownClassName="auto-grow-dropdown"
                            //dropdownClassName="auto-grow-dropdown enrollment-dropdown"
                            disabled={isEdit && !isSave}
                            component={FieldDropSide}
                          />
                          {values[fields.prospectiveOrRetrospective] &&
                          values[fields.prospectiveOrRetrospective] != 3 ? (
                            <>
                              <Field
                                size="sm"
                                name={fields.isCoincidingApplicable}
                                label={`Is "coinciding with" applicable?`}
                                isRequired
                                options={yesNoOptions}
                                selectedValue={
                                  values[fields.isCoincidingApplicable]
                                }
                                value={values[fields.isCoincidingApplicable]}
                                onChange={onisCoincidingApplicableChange}
                                component={FieldButtonGroup}
                                disabled={isEdit && !isSave}
                              />
                            </>
                          ) : null}
                        </>
                      )}
                    <Field
                      size="sm"
                      isRequired
                      name={fields.isSwitchToPlanYearHaveDifferentEntryDates}
                      label={`Does "switch to plan year" have different entry dates?`}
                      options={yesNoOptions}
                      selectedValue={
                        values[fields.isSwitchToPlanYearHaveDifferentEntryDates]
                      }
                      value={
                        values[fields.isSwitchToPlanYearHaveDifferentEntryDates]
                      }
                      onChange={onIsDifferentEntryDateChange}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                    {values[
                      fields.isSwitchToPlanYearHaveDifferentEntryDates
                    ] && (
                      <>
                        <Field
                          name={fields.additionalEntryDateRule}
                          label={`"Switch to plan year" entry date`}
                          value={values[fields.additionalEntryDateRule]}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                          )}
                          popupContent={
                            <SearchableList
                              isRadio
                              isNotTypeAhead
                              label="Select an plan year entry date"
                              selectedValue={
                                values[fields.additionalEntryDateRule]
                              }
                              options={toOptionValuesFromMapper(
                                OPTIONS_DATA_MAPPER.ENROLLMENT_PLAN_ENTRYDATE
                              )}
                              onSelect={(value) => {
                                setFieldValue(
                                  fields.additionalEntryDateRule,
                                  value
                                );

                                value == 6 &&
                                  setFieldValue(
                                    fields.additionalProspectiveOrRetrospective,
                                    null
                                  );
                                setFieldValue(
                                  fields.isCoincidingApplicableForAdditional,
                                  null
                                );

                                value == 7 &&
                                  setFieldValue(
                                    fields.additionalProspectiveOrRetrospective,
                                    null
                                  );

                                value != 7 &&
                                  setFieldValue(
                                    fields.planYearOtherEntryDates,
                                    []
                                  );
                                setAdditionalDates([
                                  {
                                    ruleId: entryDateClassificationListData.id,
                                    month: 0,
                                    day: 0,
                                  },
                                ]);
                                setFieldValue(
                                  fields.additionalOtherDescription,
                                  null
                                );
                              }}
                            />
                          }
                          isRequired
                          dropdownClassName="auto-grow-dropdown"
                          disabled={isEdit && !isSave}
                          component={FieldDropSide}
                        />
                        {values[fields.additionalEntryDateRule] &&
                          values[fields.additionalEntryDateRule] === 7 && (
                            <>
                              <div className="small mb-1">
                                {`"Switch to plan year" other entry date`}
                              </div>
                              {additionalDates
                                .filter((_) => !_.isDeleted)
                                .map((x, i) => {
                                  return (
                                    <>
                                      <Row>
                                        {i == 0 && (
                                          <>
                                            <Col md="2">
                                              <div style={mystyle}>
                                                {"Month"}
                                              </div>
                                            </Col>
                                            <Col md="2">
                                              <div style={mystyle}>{"Day"}</div>
                                            </Col>
                                          </>
                                        )}
                                      </Row>
                                      <Row>
                                        <Col md="2">
                                          <Field
                                            isRequired
                                            name={`addMonth${i}`}
                                            {...rest}
                                            size="sm"
                                            placeholder="Month"
                                            value={x.month}
                                            options={months.data}
                                            disabled={isEdit && !isSave}
                                            popupContent={
                                              <SearchableList
                                                label="Select a month"
                                                isNotTypeAhead
                                                options={months.data}
                                                onSelect={(value) => {
                                                  handleInputChange1(
                                                    "month",
                                                    value,
                                                    i
                                                  );
                                                }}
                                                selectedValue={x.month}
                                              />
                                            }
                                            component={FieldDropSide}
                                          />
                                        </Col>
                                        <Col md="2">
                                          <Field
                                            name={`addDay${i}`}
                                            {...rest}
                                            size="xs"
                                            placeholder="Date"
                                            isRequired
                                            value={x.day}
                                            disabled={isEdit && !isSave}
                                            popupContent={
                                              <DayDropdown
                                                fromMonthDate={
                                                  new Date(
                                                    2019,
                                                    x.month - 1 || 0
                                                  )
                                                }
                                                onSelect={(value) => {
                                                  handleInputChange1(
                                                    "day",
                                                    value,
                                                    i
                                                  );
                                                }}
                                                value={x.day}
                                              />
                                            }
                                            component={FieldDropSide}
                                          />
                                        </Col>
                                        <Col md="1">
                                          {additionalDates.filter(
                                            (_) => !_.isDeleted
                                          ).length -
                                            1 ===
                                            i && (
                                            <Button
                                              variant="link"
                                              style={{ marginLeft: "5px" }}
                                              disabled={
                                                isEdit ||
                                                x.month === 0 ||
                                                x.day === 0
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faPlus}
                                                color="#212529"
                                                style={{
                                                  fontSize: "1.4rem",
                                                  color: "#3a3974",
                                                  marginLeft: "5px",
                                                }}
                                                onClick={() => handleAdd(i)}
                                              />
                                            </Button>
                                          )}
                                        </Col>
                                        <Col md="1">
                                          {additionalDates.filter(
                                            (_) => !_.isDeleted
                                          ).length !== 1 && (
                                            <>
                                              <Button
                                                variant="link"
                                                disabled={isEdit && !isSave}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTrashAlt}
                                                  color="#212529"
                                                  style={{
                                                    fontSize: "1.2rem",
                                                    color: "red",
                                                    marginLeft: "5px",
                                                  }}
                                                  onClick={() =>
                                                    handleRemove(i, errors)
                                                  }
                                                />
                                              </Button>
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                    </>
                                  );
                                })}
                            </>
                          )}
                        {values[fields.additionalEntryDateRule] &&
                          values[fields.additionalEntryDateRule] != 6 &&
                          values[fields.additionalEntryDateRule] != 7 && (
                            <>
                              <Field
                                name={
                                  fields.additionalProspectiveOrRetrospective
                                }
                                label="Prospective / Retrospective criteria"
                                value={
                                  values[
                                    fields.additionalProspectiveOrRetrospective
                                  ]
                                }
                                isRequired
                                options={toOptionValuesFromMapper(
                                  OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                                )}
                                popupContent={
                                  <SearchableList
                                    isRadio
                                    isNotTypeAhead
                                    label="Select a Prospective/Retrospective"
                                    selectedValue={
                                      values[
                                        fields
                                          .additionalProspectiveOrRetrospective
                                      ]
                                    }
                                    options={toOptionValuesFromMapper(
                                      OPTIONS_DATA_MAPPER.ENROLLMENT_PROSPECTIVEORRETROSPECTIVE
                                    )}
                                    onSelect={(value) => {
                                      setFieldValue(
                                        fields.additionalProspectiveOrRetrospective,
                                        value
                                      );
                                      value == 3 &&
                                        setFieldValue(
                                          fields.isCoincidingApplicableForAdditional,
                                          null
                                        );
                                    }}
                                  />
                                }
                                dropdownClassName="auto-grow-dropdown"
                                //dropdownClassName="auto-grow-dropdown enrollment-dropdown"
                                disabled={isEdit && !isSave}
                                component={FieldDropSide}
                              />
                              {values[
                                fields.additionalProspectiveOrRetrospective
                              ] != 3 && (
                                <>
                                  <Field
                                    size="sm"
                                    name={
                                      fields.isCoincidingApplicableForAdditional
                                    }
                                    label={`Is "coinciding with" applicable?`}
                                    isRequired
                                    options={yesNoOptions}
                                    selectedValue={
                                      values[
                                        fields
                                          .isCoincidingApplicableForAdditional
                                      ]
                                    }
                                    value={
                                      values[
                                        fields
                                          .isCoincidingApplicableForAdditional
                                      ]
                                    }
                                    onChange={(value) =>
                                      setFieldValue(
                                        fields.isCoincidingApplicableForAdditional,
                                        value
                                      )
                                    }
                                    component={FieldButtonGroup}
                                    disabled={isEdit && !isSave}
                                  />
                                </>
                              )}
                            </>
                          )}
                      </>
                    )}

                    <div className="line-separator"></div>
                    <div className="d-flex justify-content-between bg-title">
                      <div>
                        <h4 className="ft-20">Additional Entry Date Rules</h4>
                      </div>
                      <div>
                        <AddButton
                          disabled={isEdit && !isSave}
                          menu="plan"
                          subMenu="entryDateClassification"
                          onAddClick={addAdditionalEntryDateClassificationClick}
                        />
                      </div>
                    </div>

                    {isEmpty(additionalEntryDateClassificationRulesData) && (
                      <AddPlans
                        menu="plan"
                        subMenu="entryDateClassification"
                        content="No additional rules"
                        buttonLabel="Add Additional Entry Date Rule"
                        className="h-auto"
                        disabled={isEdit && !isSave}
                        onPrimaryClick={
                          addAdditionalEntryDateClassificationClick
                        }
                      />
                    )}
                    {!isEmpty(additionalEntryDateClassificationRulesData) && (
                      <div className="w-100">
                        <Table>
                          <Table.Thead>
                            <Table.Tr>
                              {columns.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {additionalEntryDateClassificationRulesData.map(
                              (additionalEntryDateClassification, index) => {
                                return (
                                  <Table.Tr key={index}>
                                    {columns.map((item, cellIndex) => {
                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {!isEmpty(item.link) ? (
                                            <Link
                                              onClick={() => {
                                                editAdditionalEntryDateClassificationRuleClick(
                                                  item,
                                                  index
                                                );
                                              }}
                                            >
                                              {additionalEntryDateClassification[
                                                item.columnName
                                              ].length > 20 ? (
                                                <AddToolTip
                                                  name={
                                                    additionalEntryDateClassification[
                                                      item.columnName
                                                    ]
                                                  }
                                                >
                                                  {(
                                                    additionalEntryDateClassification[
                                                      item.columnName
                                                    ] || ""
                                                  ).slice(0, 20)}
                                                  ...
                                                </AddToolTip>
                                              ) : (
                                                additionalEntryDateClassification[
                                                  item.columnName
                                                ]
                                              )}
                                              {/* {
                                              additionalEntryDateClassification[
                                                item.columnName
                                              ]
                                            } */}
                                            </Link>
                                          ) : item.dataMapper ? (
                                            item.dataMapper[
                                              additionalEntryDateClassification[
                                                item.columnName
                                              ]
                                            ]
                                          ) : (
                                            additionalEntryDateClassification[
                                              item.columnName
                                            ]
                                          )}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              }
                            )}
                          </Table.Tbody>
                        </Table>
                      </div>
                    )}
                  </>
                )}
                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick1}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AddEntryDateClassificationContainer;
